import styled from '@emotion/styled'
import LoginIcon from './LoginIcon'
import { useShop } from 'shop/hooks'

const CartActions = () => {
  const { isStoreLoading } = useShop()

  if (isStoreLoading) return null
  return (
    <Actions>
      <LoginIcon />
    </Actions>
  )
}

const Actions = styled.div(() => ({
  display: 'flex',
  alignItems: 'center',
  height: '100%',
  gap: '12px'
}))

export default CartActions
